import { gql } from '@apollo/client';

export default gql`
  mutation deleteBulkVouchers($serviceNumber: String!, $travelDate: String!) {
    deleteBulkVouchers(serviceNumber: $serviceNumber, travelDate: $travelDate)
  }
`;
